import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { MbRegisterReq, MbRegisterResp } from 'app/bff/models/mb/mbRegister';
import { ProcessStepCodesEnum } from 'app/features/Member/Register/General/types';
import { FormValues as ClausesFormValues } from 'app/features/Member/Register/General/Clauses/types';
import { FormValues as PersonalInfoFormValues } from 'app/features/Member/Register/General/PersonalInfo/types';
import { GeneralState, GeneralActions, MEMBER_REGISTER_GENERAL__SET_ACCESSIBLE_STEP, MEMBER_REGISTER_GENERAL__SAVE_CLAUSES_PAGE_DATA, MEMBER_REGISTER_GENERAL__SAVE_PERSONAL_INFO_PAGE_DATA, MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP, MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP_DONE, MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP, MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP_DONE, MEMBER_REGISTER_GENERAL__AUTH_MOBILE_OTP, MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP, MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP_DONE, MEMBER_REGISTER_GENERAL__AUTH_EMAIL_OTP, MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA, MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA_DONE, MEMBER_REGISTER_GENERAL__UPDATE_CACHE, MEMBER_REGISTER_GENERAL__RESET_CACHE } from './types';

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 緩存「同意相關告知事項」(Step-1) 頁面資料 (Action)
 * @param data 頁面資料
 */
export const saveClausesPageDataAction = (data: ClausesFormValues): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__SAVE_CLAUSES_PAGE_DATA,
  payload: { data }
});

/**
 * @description 緩存「填寫資料」(Step-2) 頁面資料 (Action)
 * @param data 頁面資料
 */
export const savePersonalInfoPageDataAction = (data: PersonalInfoFormValues): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__SAVE_PERSONAL_INFO_PAGE_DATA,
  payload: { data }
});

/**
 * @description 發送手機 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const sendMobileOTPAction = (args: AaOtpSendcodeReq): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP,
  payload: { args }
});

/**
 * @description 發送手機 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendMobileOTPDoneAction = (response: AaOtpSendcodeResp): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP_DONE,
  payload: { response }
});

/**
 * @description 重新發送手機 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const resendMobileOTPAction = (args: AaOtpSendcodeReq): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP,
  payload: { args }
});

/**
 * @description 重新發送手機 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const resendMobileOTPDoneAction = (response: AaOtpSendcodeResp): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證手機 OTP 驗證碼 (Action)
 * @param authMobileOTPArgs 驗證手機 OTP 驗證碼，請求所需的參數
 * @param sendEmailOTPArgs 發送信箱 OTP 驗證碼，請求所需的參數
 */
export const authMobileOTPAction = (authMobileOTPArgs: AaOtpVerifyReq, sendEmailOTPArgs: AaOtpSendcodeReq): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__AUTH_MOBILE_OTP,
  payload: { authMobileOTPArgs, sendEmailOTPArgs }
});

/**
 * @description 發送信箱 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const sendEmailOTPAction = (args: AaOtpSendcodeReq): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP,
  payload: { args }
});

/**
 * @description 發送信箱 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendEmailOTPDoneAction = (response: AaOtpSendcodeResp): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證信箱 OTP 驗證碼 (Action)
 * @param authEmailOTPArgs 驗證手機 OTP 驗證碼，請求所需的參數
 * @param registerArgs 註冊會員，請求所需的參數
 */
export const authEmailOTPAction = (authEmailOTPArgs: AaOtpVerifyReq, registerArgs: MbRegisterReq): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__AUTH_EMAIL_OTP,
  payload: { authEmailOTPArgs, registerArgs }
});

/**
 * @description 送出會員資料執行註冊 (Action)
 * @param args 請求所需的參數
 */
export const sendRegisterDataAction = (args: MbRegisterReq): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA,
  payload: { args }
});

/**
 * @description 送出會員資料執行註冊 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendRegisterDataDoneAction = (response: MbRegisterResp): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA_DONE,
  payload: { response }
});

/**
 * @description 更新資料緩存 (Action)
 * @param cache 緩存資料
 */
export const updateCacheAction = (cache: GeneralState): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__UPDATE_CACHE,
  payload: { cache }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): GeneralActions => ({
  type: MEMBER_REGISTER_GENERAL__RESET_CACHE
});
